(function(){
'use strict';
var $=function(s,c){return (c||document).querySelector(s)};
var $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
var money=function(cents){
  try{
    var f=(window.NADA&&window.NADA.moneyFormat)||'{{amount}} MAD';
    var v=(cents/100).toFixed(2);
    if(f.indexOf('amount_no_decimals')>-1){v=Math.round(cents/100).toString()}
    return f.replace(/\{\{\s*amount(_no_decimals)?(_with_comma_separator)?\s*\}\}/g,v);
  }catch(e){return (cents/100).toFixed(2)}
};

/* ---------- scroll reveal ---------- */
function reveal(){
  var els=$$('.reveal:not(.is-in)');
  if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')});return}
  var io=new IntersectionObserver(function(en){
    en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}})
  },{rootMargin:'0px 0px -8% 0px',threshold:.08});
  els.forEach(function(e){io.observe(e)});
}

/* ---------- header auto-hide ---------- */
function header(){
  var h=$('.hdr'); if(!h) return;
  var last=0;
  window.addEventListener('scroll',function(){
    var y=window.pageYOffset;
    if(document.body.classList.contains('nada-lock')) return;
    if(y>last&&y>240){h.classList.add('hdr--hidden')}else{h.classList.remove('hdr--hidden')}
    last=y;
  },{passive:true});
}

/* ---------- announcement rotator ---------- */
function announce(){
  var w=$('[data-ann]'); if(!w) return;
  var items=$$('.ann__item',w); if(items.length<2) return;
  var i=0;
  setInterval(function(){
    items[i].classList.remove('is-on');
    i=(i+1)%items.length;
    items[i].classList.add('is-on');
  },4500);
}

/* ---------- drawers ---------- */
var lockCount=0;
function lock(on){
  lockCount=Math.max(0,lockCount+(on?1:-1));
  document.body.classList.toggle('nada-lock',lockCount>0);
  document.body.style.overflow=lockCount>0?'hidden':'';
}
function openDrawer(id){
  var d=document.getElementById(id); if(!d) return;
  d.classList.add('is-open'); d.setAttribute('aria-hidden','false'); lock(true);
  var f=d.querySelector('button,a,input'); if(f) setTimeout(function(){f.focus()},60);
}
function closeDrawer(d){
  if(!d||!d.classList.contains('is-open')) return;
  d.classList.remove('is-open'); d.setAttribute('aria-hidden','true'); lock(false);
}
function drawers(){
  document.addEventListener('click',function(e){
    var o=e.target.closest('[data-open]');
    if(o){e.preventDefault();openDrawer(o.getAttribute('data-open'));return}
    var c=e.target.closest('[data-close]');
    if(c){e.preventDefault();closeDrawer(c.closest('.drawer'));return}
    if(e.target.classList.contains('drawer__scrim')){closeDrawer(e.target.closest('.drawer'))}
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){$$('.drawer.is-open').forEach(closeDrawer);closeMega()}
  });
}

/* ---------- mega menu ---------- */
var megaTimer=null;
function closeMega(){
  $$('.mega.is-open').forEach(function(m){m.classList.remove('is-open')});
  $$('.hdr__l[aria-expanded="true"]').forEach(function(b){b.setAttribute('aria-expanded','false')});
}
function mega(){
  var trigs=$$('[data-mega]');
  if(!trigs.length) return;
  trigs.forEach(function(t){
    var panel=document.getElementById(t.getAttribute('data-mega'));
    if(!panel) return;
    function open(){clearTimeout(megaTimer);closeMega();panel.classList.add('is-open');t.setAttribute('aria-expanded','true')}
    function close(){megaTimer=setTimeout(function(){panel.classList.remove('is-open');t.setAttribute('aria-expanded','false')},180)}
    t.addEventListener('mouseenter',open);
    t.addEventListener('focus',open);
    t.addEventListener('mouseleave',close);
    panel.addEventListener('mouseenter',function(){clearTimeout(megaTimer)});
    panel.addEventListener('mouseleave',close);
    t.addEventListener('click',function(e){
      if(t.getAttribute('aria-expanded')==='true'){return}
      e.preventDefault();open();
    });
  });
}

/* ---------- accordions ---------- */
function accordions(){
  document.addEventListener('click',function(e){
    var b=e.target.closest('.acc__b'); if(!b) return;
    var p=b.nextElementSibling; if(!p) return;
    var open=b.getAttribute('aria-expanded')==='true';
    b.setAttribute('aria-expanded',open?'false':'true');
    if(open){p.style.height=p.scrollHeight+'px';requestAnimationFrame(function(){p.style.height='0px'})}
    else{p.style.height=p.scrollHeight+'px';setTimeout(function(){if(b.getAttribute('aria-expanded')==='true')p.style.height='auto'},420)}
  });
}

/* ---------- tabs (ingredients) ---------- */
function tabs(){
  $$('[data-tabs]').forEach(function(root){
    var btns=$$('[role="tab"]',root), panes=$$('[role="tabpanel"]',root);
    btns.forEach(function(b,i){
      b.addEventListener('click',function(){
        btns.forEach(function(x){x.setAttribute('aria-selected','false')});
        panes.forEach(function(p){p.classList.remove('is-on')});
        b.setAttribute('aria-selected','true');
        if(panes[i])panes[i].classList.add('is-on');
      });
      b.addEventListener('keydown',function(e){
        var n=null;
        if(e.key==='ArrowRight'||e.key==='ArrowDown')n=btns[i+1]||btns[0];
        if(e.key==='ArrowLeft'||e.key==='ArrowUp')n=btns[i-1]||btns[btns.length-1];
        if(n){e.preventDefault();n.focus();n.click()}
      });
    });
  });
}

/* ---------- rails ---------- */
function rails(){
  $$('[data-rail-root]').forEach(function(root){
    var rail=$('.rail',root), prev=$('[data-rail-prev]',root), next=$('[data-rail-next]',root);
    if(!rail||!prev||!next) return;
    function step(){var c=rail.firstElementChild;return c?c.getBoundingClientRect().width+24:300}
    function sync(){
      prev.disabled=rail.scrollLeft<8;
      next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-8;
    }
    prev.addEventListener('click',function(){rail.scrollBy({left:-step()*2,behavior:'smooth'})});
    next.addEventListener('click',function(){rail.scrollBy({left:step()*2,behavior:'smooth'})});
    rail.addEventListener('scroll',sync,{passive:true});
    window.addEventListener('resize',sync);
    sync();
  });
}

/* ---------- cart ---------- */
function updateCartCount(n){
  $$('[data-cart-count]').forEach(function(el){
    el.textContent=n;
    el.style.display=n>0?'':'none';
  });
}
function renderCart(cart){
  updateCartCount(cart.item_count);
  var body=$('[data-cart-body]'), foot=$('[data-cart-foot]');
  if(!body) return;
  if(!cart.item_count){
    body.innerHTML='<div class="empty"><h2>Votre panier est vide</h2><p class="muted">Découvrez nos huiles végétales pressées à froid et nos rituels de soin.</p><p style="margin-top:1.5rem"><a class="btn btn--primary" href="/collections/all">Découvrir la boutique</a></p></div>';
    if(foot)foot.style.display='none';
    return;
  }
  if(foot)foot.style.display='';
  var html='';
  cart.items.forEach(function(it){
    var img=it.image?it.image.replace(/(\.[a-z]+)(\?|$)/i,'_200x250_crop_center$1$2'):'';
    html+='<div class="cline" data-key="'+it.key+'">'+
      '<a href="'+it.url+'">'+(img?'<img class="cline__img" src="'+img+'" alt="" loading="lazy" width="76" height="95">':'<span class="cline__img"></span>')+'</a>'+
      '<div><a href="'+it.url+'" class="cline__t">'+it.product_title+'</a>'+
      (it.variant_title&&it.variant_title!=='Default Title'?'<div class="cline__v">'+it.variant_title+'</div>':'')+
      '<div class="cline__row"><div class="qty">'+
      '<button type="button" data-cq="-1" aria-label="Diminuer">&minus;</button>'+
      '<input type="number" value="'+it.quantity+'" min="0" data-cqi aria-label="Quantité">'+
      '<button type="button" data-cq="1" aria-label="Augmenter">+</button>'+
      '</div><strong>'+money(it.final_line_price)+'</strong></div>'+
      '<div style="margin-top:.5rem"><button type="button" class="cline__rm" data-cq="0">Retirer</button></div>'+
      '</div></div>';
  });
  body.innerHTML=html;
  var tot=$('[data-cart-total]'); if(tot)tot.textContent=money(cart.total_price);
}
function fetchCart(){
  return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){renderCart(c);return c});
}
function changeLine(key,qty){
  var body=$('[data-cart-body]'); if(body)body.style.opacity='.5';
  return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
    .then(function(r){return r.json()}).then(function(c){renderCart(c);if(body)body.style.opacity='';return c});
}
function cart(){
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-cq]'); if(!b) return;
    var line=b.closest('.cline'); if(!line) return;
    var key=line.getAttribute('data-key');
    var delta=parseInt(b.getAttribute('data-cq'),10);
    var input=$('[data-cqi]',line);
    var q=delta===0?0:Math.max(0,parseInt(input.value,10)+delta);
    changeLine(key,q);
  });
  document.addEventListener('change',function(e){
    var i=e.target.closest('[data-cqi]'); if(!i) return;
    var line=i.closest('.cline');
    changeLine(line.getAttribute('data-key'),Math.max(0,parseInt(i.value,10)||0));
  });
  document.addEventListener('submit',function(e){
    var f=e.target.closest('[data-atc-form]'); if(!f) return;
    e.preventDefault();
    var btn=f.querySelector('[type="submit"]');
    var label=btn?btn.textContent:'';
    if(btn){btn.setAttribute('aria-disabled','true');btn.textContent='Ajout…'}
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
      .then(function(r){return r.json().then(function(j){return{ok:r.ok,j:j}})})
      .then(function(res){
        if(btn){btn.removeAttribute('aria-disabled');btn.textContent=label}
        if(!res.ok){
          var err=f.querySelector('[data-atc-err]');
          if(err){err.textContent=res.j.description||res.j.message||'Ce produit n’a pas pu être ajouté.';err.style.display=''}
          return;
        }
        return fetchCart().then(function(){openDrawer('nada-cart')});
      }).catch(function(){if(btn){btn.removeAttribute('aria-disabled');btn.textContent=label}});
  });
}

/* ---------- product variants ---------- */
function product(){
  var root=$('[data-product]'); if(!root) return;
  var data=null;
  try{data=JSON.parse($('[data-variants]',root).textContent)}catch(e){return}
  var idInput=$('[data-variant-id]',root);
  var priceEl=$('[data-price]',root);
  var btn=$('[data-atc-btn]',root);
  var satcPrice=$('[data-satc-price]');

  function selected(){
    return $$('[data-opt]',root).map(function(g){
      var on=g.querySelector('[aria-checked="true"]');
      return on?on.getAttribute('data-val'):null;
    });
  }
  function match(sel){
    for(var i=0;i<data.length;i++){
      var v=data[i],ok=true;
      for(var k=0;k<sel.length;k++){ if(sel[k]&&v.options[k]!==sel[k]){ok=false;break} }
      if(ok) return v;
    }
    return null;
  }
  function apply(v){
    if(!v){if(btn){btn.setAttribute('aria-disabled','true');btn.textContent='Indisponible'}return}
    if(idInput)idInput.value=v.id;
    var html=money(v.price)+(v.compare_at_price&&v.compare_at_price>v.price?' <s>'+money(v.compare_at_price)+'</s>':'');
    if(priceEl)priceEl.innerHTML=html;
    if(satcPrice)satcPrice.innerHTML=money(v.price);
    if(btn){
      if(v.available){btn.removeAttribute('aria-disabled');btn.textContent='Ajouter au panier'}
      else{btn.setAttribute('aria-disabled','true');btn.textContent='Épuisé'}
    }
    if(history.replaceState){
      var u=new URL(window.location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u.toString());
    }
    var media=root.querySelector('[data-media="'+v.id+'"]');
    if(media)media.scrollIntoView({behavior:'smooth',block:'center'});
  }
  root.addEventListener('click',function(e){
    var b=e.target.closest('[data-val]'); if(!b) return;
    var g=b.closest('[data-opt]');
    $$('[data-val]',g).forEach(function(x){x.setAttribute('aria-checked','false')});
    b.setAttribute('aria-checked','true');
    apply(match(selected()));
  });
  apply(match(selected()));

  /* sticky mobile ATC */
  var satc=$('.satc');
  if(satc&&btn){
    document.body.classList.add('has-satc');
    var io=new IntersectionObserver(function(en){
      satc.classList.toggle('is-on',!en[0].isIntersecting);
    },{rootMargin:'-90px 0px 0px 0px'});
    io.observe(btn);
    $('[data-satc-btn]',satc)&&$('[data-satc-btn]',satc).addEventListener('click',function(){
      var f=btn.closest('form'); if(f)f.requestSubmit?f.requestSubmit():f.submit();
    });
  }
}

/* ---------- pro inquiry form UX ---------- */
function proForm(){
  $$('[data-pro-form]').forEach(function(f){
    f.addEventListener('submit',function(){
      var b=f.querySelector('[type="submit"]');
      if(b){b.setAttribute('aria-disabled','true');b.textContent='Envoi…'}
    });
  });
}

/* ---------- collection sort ---------- */
function collectionSort(){
  var s=$('[data-sort]'); if(!s) return;
  s.addEventListener('change',function(){
    var u=new URL(window.location.href);
    u.searchParams.set('sort_by',s.value);
    u.searchParams.delete('page');
    window.location.href=u.toString();
  });
}

document.addEventListener('DOMContentLoaded',function(){
  reveal();header();announce();drawers();mega();accordions();tabs();rails();cart();product();proForm();collectionSort();
  fetchCart();
});
document.addEventListener('shopify:section:load',function(){reveal();tabs();rails();mega()});
})();
